var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLineArrowRight = function SvgLineArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.625,
    y: 14.625,
    width: 2.25,
    height: 15.75,
    rx: 1,
    transform: "rotate(-90 5.625 14.625)",
    fill: "#ADB5BD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7045 19.4545C12.2652 19.8938 12.2652 20.6062 12.7045 21.0455C13.1438 21.4848 13.8562 21.4848 14.2955 21.0455L21.0455 14.2955C21.4714 13.8696 21.4863 13.1838 21.0793 12.7398L14.8918 5.98981C14.472 5.5318 13.7603 5.50086 13.3023 5.9207C12.8443 6.34054 12.8134 7.05218 13.2332 7.51019L18.6928 13.4662L12.7045 19.4545Z",
    fill: "currentcolor"
  })));
};
export default SvgLineArrowRight;